/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ResetTripwireRequest, Tripwire } from "../models/index";
import {
  ResetTripwireRequestFromJSON,
  ResetTripwireRequestToJSON,
  TripwireFromJSON,
  TripwireToJSON,
} from "../models/index";

export interface ResetTripwireOperationRequest {
  resetTripwireRequest: ResetTripwireRequest;
}

/**
 *
 */
export class TripwiresApi extends runtime.BaseAPI {
  /**
   */
  async getAllTripwiresRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Tripwire>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/tripwires/get-all-tripwires`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TripwireFromJSON),
    );
  }

  /**
   */
  async getAllTripwires(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Tripwire>> {
    const response = await this.getAllTripwiresRaw(initOverrides);
    return await response.value();
  }

  /**
   * Re-arms a tripwire. Deliberately the only way one is ever cleared: an automatic reset would quietly start sending a rejected credential again, which is what gets an account locked in the first place. Fix the credential first, then press this.
   * Re-arms a tripwire.
   */
  async resetTripwireRaw(
    requestParameters: ResetTripwireOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["resetTripwireRequest"] == null) {
      throw new runtime.RequiredError(
        "resetTripwireRequest",
        'Required parameter "resetTripwireRequest" was null or undefined when calling resetTripwire().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/tripwires/reset-tripwire`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ResetTripwireRequestToJSON(
          requestParameters["resetTripwireRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Re-arms a tripwire. Deliberately the only way one is ever cleared: an automatic reset would quietly start sending a rejected credential again, which is what gets an account locked in the first place. Fix the credential first, then press this.
   * Re-arms a tripwire.
   */
  async resetTripwire(
    requestParameters: ResetTripwireOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.resetTripwireRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
